import { gql } from "@apollo/client";

export const CREATE_UNIT = gql`
  mutation CreateUnit($input: UnitInput) {
    createUnit(input: $input) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const GET_UNIT_PAGINATION = gql`
  query GetUnitPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $keyword: String
    $isUse: Boolean
  ) {
    getUnitPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      keyword: $keyword
      isUse: $isUse
    ) {
      data {
        _id
        unitKhName
        unitEnName
        isUse
        remark
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_ISUSE_STATUS = gql`
  mutation UpdateUnitIsUse($id: ID!, $isUse: Boolean) {
    updateUnitIsUse(_id: $id, isUse: $isUse) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const UPDATE_UNIT = gql`
  mutation UpdateUnit($id: ID!, $input: UnitInput) {
    updateUnit(_id: $id, input: $input) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const DELETE_UNIT = gql`
  mutation DeleteUnit($id: ID!) {
    deleteUnit(_id: $id) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const SELECT_UNIT_BYID = gql`
  query SelectUnitByMaterialId($materialId: ID) {
    selectUnitByMaterialId(materialId: $materialId) {
      _id
      materialId {
        _id
        materialKhName
        materialEnName
        categoryId {
          isUse
        }
        groupId {
          _id
          groupKhName
          groupEnName
        }
        smallUnitId {
          _id
          unitKhName
          unitEnName
        }
        sizeId {
          _id
          sizeEnName
          sizeKhName
        }
        isUse
        remark
      }
      imageSrc
      unitId {
        _id
        unitKhName
        unitEnName
      }
      qtyInUnit
      costPerUnit
      barcode
    }
  }
`;
